import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getCountriesQuery } from "rsl-api-106/lib/queries";
import { Query, QueryGetCountriesArgs } from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import { useSession } from "@hooks";

import { SelectOptionType } from "../../../../types";
import Select from "../Select";
import { SelectProps } from "../Select/Select";

interface SelectCountryProps extends SelectProps {
  //
}

const languagesVarsCodes = [
  "LANG_neobooking_countries_choose", //Choisir une brochure
  "LANG_neobooking_countries_loading", //Chargement des brochures...
];

const SelectCountry: React.FC<SelectCountryProps> = ({ ...props }) => {
  /* Hooks */
  const { sessionId, getLanguageVarValue } = useSession();
  const { data, error, loading } = useQuery<Query, QueryGetCountriesArgs>(
    getCountriesQuery(),
    {
      variables: { session: { name: sessionId!! } },
    }
  );

  /* State */
  const [countriesOptions, setCountriesOptions] = useState<SelectOptionType[]>(
    []
  );

  useEffect(() => {
    if (data && data.getCountries?.countryList) {
      const options: SelectOptionType[] =
        data.getCountries.countryList?.map((x) => {
          return {
            value: x?.code as string,
            label: x?.label as string,
          };
        }) ?? [];
      setCountriesOptions(options);
    }
  }, [data]);

  return (
    <>
      <Select
        placeholder={
          props.placeholder
            ? props.placeholder
            : getLanguageVarValue("LANG_neobooking_countries_choose")
        }
        loadingPlaceholder={
          props.loadingPlaceholder
            ? props.loadingPlaceholder
            : getLanguageVarValue("LANG_neobooking_countries_loading")
        }
        empty={countriesOptions && isEmpty(countriesOptions)}
        {...props}
        options={countriesOptions}
        style={{
          color: props.value && !isEmpty(props.value) ? "black" : "#a3a3a3",
        }}
      />
    </>
  );
};

SelectCountry.propTypes = {
  //
};

export default SelectCountry;
